<template>
  <div class="button-group mt-1 mb-2">
    <div class="d-flex flex-wrap">
      <span class="option" :class="option.title.replace(' ', '-').toLowerCase()" v-for="option in options" @click.stop="select(option)">
      <button :class="selected.includes(option) ? ' selected' : '' " class="white">
        <span class="optiontitle">{{ option.title }}</span>
      </button>
    </span>
    </div>
  </div>
</template>
<script>
module.exports = {
  data() {
    return {
      name: '',
      options: [],
      selected: [],
      isMulti: false,
      title: '',
    };
  },
  props: ['config'],
  computed: {
  },
  methods: {
    select(option, silent = false) {
      if (!this.isMulti) {
        //this is not a multiselect
        this.selected = [option];
      } else {
        //this is multiselect, remove or append
        if (this.selected.includes(option)) {
          this.selected.splice(this.selected.indexOf(option), 1);
        } else {
          this.selected.push(option);
        }
        //More than one selected, remove resetvalues
        if (this.selected.length > 1) {
          this.selected.forEach((element) => {
            if (element.reset) {
              this.selected.splice(this.selected.indexOf(element), 1);
            }
          });
        }
        //None selected, default to first
        if (this.selected.length < 1) {
          this.selected = [this.options[0]];
        }
        //Resetvalue is chosen, remove all
        if (option.reset) {
          this.selected = [option];
        }
      }
      this.setQueryParams();
      this.emitSelect();
    },
    /*
     * Returns option by name, or value if name is not existing
     */
    getOptionByNameOrValue(value) {
      let foundOption = false;
      this.options.forEach((option) => {
        if (option.name == value || option.value == value) {
          foundOption = option;
        }
      });
      return foundOption;
    },
    getQueryParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const selected = this.selected;
      if (urlParams.has(this.name)) {
        const params = urlParams.get(this.name).split(',');
        params.forEach((param) => {
          const option = this.getOptionByNameOrValue(param);
          if (option) {
            this.select(option, true);
          }
        });
      }
    },
    setQueryParams() {
      const selectedValueElement = [];
      let value = '';
      this.selected.forEach((element) => {
        selectedValueElement.push(element.value);
      });
      value = selectedValueElement.join(',');
      const urlParams = new URLSearchParams(window.location.search);
      if (value == '') {
        urlParams.delete(this.name);
      } else {
        urlParams.set(this.name, value);
      }
      window.history.replaceState(null, null, '?' + urlParams.toString());
    },
    setConfigData() {
      if (this.config) {
        if (this.config.name) {
          this.name = this.config.name;
        }
        if (this.config.options) {
          this.config.options.forEach((option) => {
            const tmpOption = option;
            //value must exist on option
            if(option.value){
              tmpOption.title = option.title ? option.title : option.value;

              this.options.push(tmpOption);
              //default to first option
              if(this.selected.length <= 0){
                this.selected.push(tmpOption);
              }
            }
          });
        }
        if (this.config.multiselect) {
          this.isMulti = false;
        }
        if (this.config.title) {
          this.title = this.config.title;
        }
      }
    },
    emitSelect() {
      //normalize data (data.name and data.value), make it reusable
      const data = {
        name: this.name,
        value: [],
      };
      this.selected.forEach((element) => {
        data.value.push(element);
      });
      this.$emit('button-select', data); //emit event do parent (using $emit instead of fire to not make it global)
    },
  },
  created() {
    document.addEventListener('click', this.documentClicked);
    this.setConfigData();
    this.getQueryParams();
  },
  destroyed() {
    document.removeEventListener('click', this.documentClicked);
  },
};
</script>
<style>
  .button-group button {
    font-size: 1.6rem;
    line-height: 2.2rem;
    padding: 15px 0;
    background-color: #ffffff;
    font-weight: 400;
  }

  .button-group .option {
    width: 31.3333%;
    margin-right: 2%;
    margin-bottom: .6rem;
  }

  .button-group .option:nth-child(3n) {
    margin-right: 0;
  }

  .object-type .button-group .option.kommersiell-fastighet,
  .object-area .button-group .option:last-child {
    width: 64.666%;
  }

  @media screen and (min-width: 768px) {
    .button-group .option {
      width: auto !important;
      min-width: 126px;
      margin-right: .7rem;
      margin-bottom: .6rem;
    }

    .button-group .option:nth-child(3n) {
      margin-right: .7rem;
    }

    .object-type .button-group .option.kommersiell-fastighet,
    .object-area .button-group .option:last-child {
      width: auto;
    }

    .object-area .button-group .option:last-child {
      min-width: 126px;
    }

    .button-group button {
      padding: 7px 0;
    }

    .object-type .button-group .option.kommersiell-fastighet button {
      padding: 7px 16px;
    }
  }

  .button-group .option button {
      width: 100%;
  }

  .button-group button.selected {
    background-color: #72BDBD;
    color: #fff;
    border: 1px solid #72BDBD;
  }
</style>
